/**
 * TanStack Query hooks for `contests`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	contestsQueryKeys,
	type CreateContestsBody,
	type ListContestsResponse,
	type ContestsRow,
} from "./api";

export function useContestsList(): UseQueryResult<ListContestsResponse, Error> {
	return useQuery({
		queryKey: contestsQueryKeys.list(),
		queryFn: list,
	});
}

export function useContestsCreate(): UseMutationResult<ContestsRow, Error, CreateContestsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: contestsQueryKeys.all });
		},
	});
}

export function useContestsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: contestsQueryKeys.all });
		},
	});
}
